import { render, staticRenderFns } from "./StandardJobStart.vue?vue&type=template&id=65b07671&scoped=true"
import script from "./StandardJobStart.vue?vue&type=script&lang=js"
export * from "./StandardJobStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b07671",
  null
  
)

export default component.exports